export default __webpack_public_path__ + "static/media/07AW2SEP66.24ff309d.jpg";